import Vue from 'vue';
import moment from 'moment';
export default Vue.extend({
    name: 'IdleAlert',
    props: {
        secondsLeft: {
            type: Number,
            required: true
        },
        isRefreshing: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        minutesStringJwtrToExp() {
            const duration = moment.duration(this.secondsLeft, 's');
            const minutes = duration.minutes();
            const seconds = duration.seconds() > 0 ? duration.seconds() : 1;
            return (minutes > 0 ? this.$tc('time.inMinutes', minutes) + ' ' : '') + this.$tc('time.inSeconds', seconds);
        }
    }
});
